import { PHONE_MASK } from '@/shared/constants/phoneConstants';

export const formatPhoneMasked = (raw?: string | null): string => {
  const digits = (raw ?? '').replace(/\D/g, '');
  if (digits.length !== 11) return '';
  return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
};

export const usePhoneInput = (phone: Ref<string>) => {
  const PHONE_PREFIX = '+7 (';
  const phoneMask = { mask: PHONE_MASK, eager: true };

  const onFocus = (): void => {
    if (!phone.value) phone.value = PHONE_PREFIX;
  };

  const onBlur = (): void => {
    if (phone.value === PHONE_PREFIX) phone.value = '';
  };

  const onKeydown = (event: KeyboardEvent): void => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const len = PHONE_PREFIX.length;

    if (start < len && end >= input.value.length) {
      event.preventDefault();
      phone.value = PHONE_PREFIX;
      nextTick(() => input.setSelectionRange(len, len));
      return;
    }

    if (event.key === 'Backspace' && start <= len && start === end) {
      event.preventDefault();
      nextTick(() => input.setSelectionRange(len, len));
      return;
    }

    if (event.key === 'Delete' && start < len && start === end) {
      event.preventDefault();
      nextTick(() => input.setSelectionRange(len, len));
    }
  };

  const phoneAttr = { onKeydown };

  return { PHONE_PREFIX, phoneMask, phoneAttr, onFocus, onBlur, onKeydown };
};

export default usePhoneInput;
